
import { HttpGetAreaMaintainList, HttpDeleteAreaMaintainOne, HttpExportAreaMaintain } from '@/service/account';
import TableList from "@components/templates/tablelist";
import compUpload from "@components/templates/selectupload";
import compUploadData from "./upload.vue";
import comExcel from '@components/templates/excelalert';
import { mapGetters } from 'vuex';
import compIndex from "./update";
export default {
    mixins: [TableList],
    components: {
        compIndex,
        compUpload,
        comExcel,
        compUploadData
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            workOrderSearchList: [],
        };
    },
    methods: {
        ajaxRequest: HttpGetAreaMaintainList,
        interceptRequest(data) {
            const endLocation = data.search.endLocation;
            data.endLocation = endLocation;
            delete data.search.endLocation;
            return data
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {

                case "add":
                    this.$router.push({
                        name: 'carrierareamaintainUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                        this.$router.push({
                            name: 'carrierareamaintainUpdate',
                            params: { type: "edit" },
                            query: { id: params },
                        });
                        break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "workorderorderUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        ajaxRequest: HttpDeleteAreaMaintainOne,
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                        formdata: [
                            {
                                label: this.$t('global.common.notes', { defaultValue: '备注' }),
                                tag: "vTextarea",
                                key: 'remark',
                                span: 24,
                                labelWidth: 60,
                                required:false
                            }
                        ]
                    }
                    break;
                case "import":
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        component: "compUploadData",
                        // name: "multipartFile",
                        // component: "compUpload",
                        // localurl:true,
                        // actionurl:process.env.VUE_APP_APIURL_FBB+'/api/v2/carrierZone/importCarrierZone',
                        // downrul:'/static/template/account_areamaintian.xlsx',
                        // formdata: [
                        //     {
                        //         label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                        //         tag: "Select",
                        //         key:'carrierCode',
                        //         options:this.getCarrierAllList,
                        //         props:{
                        //             filterable:true,
                        //         },
                        //         labelWidth: 90,
                        //         span:24,
                        //     },
                        //     {
                        //         label: this.$tc('',1,{defaultValue:'目的地国家'}),
                        //         tag: "Select",
                        //         key:'countryId',
                        //         options:this.getCountryList.map(item=>{
                        //             return {
                        //                 value:item.attach.id,
                        //                 label:item.label
                        //             }
                        //         }),
                        //         props:{
                        //             filterable:true,
                        //         },
                        //         labelWidth: 90,
                        //         span:24,
                        //     },
                        //     {
                        //         label: this.$tc('',1,{defaultValue:'发货地国家'}),
                        //         tag: "Select",
                        //         key:'shipRegionId',
                        //         options:this.getCountryList.map(item=>{
                        //             return {
                        //                 value:item.attach.id,
                        //                 label:item.label
                        //             }
                        //         }),
                        //         props:{
                        //             filterable:true,
                        //         },
                        //         labelWidth: 90,
                        //         span:24,
                        //     },
                        // ],
                    };
                    break;
                case "export":
                    this.handleWebfs(
                        HttpExportAreaMaintain,
                        this.interceptRequest(JSON.parse(JSON.stringify(this.formData))),
                        { executor: 'request', download: true }
                    ).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, workOrderStatus } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "carrierareamaintainUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    params: id,
                    to: {
                        name: "carrierareamaintainUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.delete', { defaultValue: '删除' }),
                    params: id,
                    operate: 'delete',
                    show: true
                },
            ];
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getOrgList','getCarrierAllList','getCountryList', 'getCarrierAllList']),
        ToolsData() {
            return [
                {
                    label: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    theme:"primary",
                },
                {
                    label: this.$t('fbb.alloment.muti_import', { defaultValue: '批量导入' }),
                    operate: "import",
                    theme:"info",
                },
                {
                    label: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    theme:"success",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.settlement.shipPostal', { defaultValue: '发货地邮编' }),
                    key: 'EQ_startLocation',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.settlement.zoneCode', { defaultValue: '分区代码' }),
                    key: 'EQ_zoneCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.settlement.endLocation', { defaultValue: '目的地代码' }),
                    key: 'endLocation',
                    tag: 'vInput',
                    show: true,
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    label: "承运商",
                    key: 'EQ_carrierCode',
                    tag: 'Select',
                    // options:this.getCarrierAllList,
                    options:this.getCarrierAllList.map(item=>{
                        return {value: item.attach.carrierCode, label: item.label}
                    }),
                    props:{
                        filterable:true
                    }
                },
                {
                    label: this.$tc('',1,{defaultValue:'目的地国家'}),
                    key: 'EQ_zoneRegionId',
                    tag: 'Select',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                    props:{
                        filterable:true
                    }
                },
                {
                    label: this.$tc('',1,{defaultValue:'发货地国家'}),
                    key: 'EQ_shipRegionId',
                    tag: 'Select',
                    options:this.getCountryList.map(item=>{
                        return {
                            value:item.attach.id,
                            label:item.label
                        }
                    }),
                    props:{
                        filterable:true
                    }
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$tc('',1,{defaultValue:'目的地国家'}),
                    key: 'zoneRegionId',
                    render:(h,{row})=>{
                        let country = this.getCountryList.filter(item=>{return item.attach.id === Number(row.zoneRegionId)})[0] || {}
                        return country.label
                    }
                    // render: (h, { row }) => this.findRenderLabel(this.getCountryList, row.zoneRegionId, 'id',true),
                },
                {
                    title: this.$tc('',1,{defaultValue:'发货地国家'}),
                    key: 'shipRegionId',
                    render:(h,{row})=>{
                        let country = this.getCountryList.filter(item=>{return item.attach.id === Number(row.shipRegionId)})[0] || {}
                        return country.label||'--'
                    }
                    // render: (h, { row }) => this.findRenderLabel(this.getCountryList, row.zoneRegionId, 'id',true),
                },
                {
                    // title: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    // key: 'carrierCode',
                    // render: (h, { row }) => this.findRenderLabel(this.getCarrierAllList, row.carrierCode),
                    title: "承运商",
                    key: 'carrierCode',
                },
                {
                    title: "承运商服务",
                    key: 'carrierServiceCode',
                    render: (h, { row }) => {
                        return <div>{row.carrierServiceCode || '--'}</div>
                    },
                },
                {
                    title: this.$t('fbb.settlement.shipPostal',{defaultValue:'发货地邮编'}),
                    key: 'startLocation',

                },
                {
                    title: this.$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'}),
                    key: 'zoneCode',
                },
                {
                    title: this.$t('fbb.settlement.ruleRangeMin',{defaultValue:'目的地邮编范围最小值'}),
                    key: 'ruleRangeMin',
                },
                {
                    title: this.$t('fbb.settlement.ruleRangeMax',{defaultValue:'目的地邮编范围最大值'}),
                    key: 'ruleRangeMax',
                }];
        },
    },
};




